export const BADGE_TAG_NAME = "badge" as const;

export const BADGE_ICON_POSITIONS = ["start", "end"] as const;

export const BADGE_VARIANTS = [
  "success",
  "info",
  "warning",
  "error",
  "neutral",
  "ghost",
  "link",
] as const;
